export const agriiProtector = {
    state: {
        status: 'idle',
        agriiProtector: null
    },
    mutations: {
        SET_AGRIIPROTECTOR_STATUS(state, status) {
            state.status = status
        },
        SET_AGRIIPROTECTOR(state, agriiProtector) {
            state.agriiProtector = agriiProtector
        },
        SET_AGRIIPROTECTOR_FAVORITE(state, isFavorite) {
            state.agriiProtector.is_favorite = isFavorite
        }
    },
    actions: {
        fetchAgriiProtector({ state, commit }, payload) {
            commit('SET_AGRIIPROTECTOR', null)
            commit('SET_AGRIIPROTECTOR_STATUS', 'loading')
            return this.$api.get(`api/agrii-protectors/${payload}.json`).then(response => {
                commit('SET_AGRIIPROTECTOR', response.data.data)
                commit('SET_AGRIIPROTECTOR_STATUS', 'idle')
            }).catch(error => {
                commit('SET_AGRIIPROTECTOR_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        agriiProtectorFavorite({ dispatch, commit }, payload) {
            commit('SET_AGRIIPROTECTOR_STATUS', 'settingFavorite')
            return this.$api.patch(`api/agrii-protectors/favorite/${payload}.json`, { favorite: true })
                .then(response => {
                    if(response.data.data.is_favorite) {
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Dodano produkt do ulubionych.'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Usunięto produkt z ulubionych.'
                        })
                    }
                    // dispatch('fetchAgriiProtector', payload)
                    commit('SET_AGRIIPROTECTOR_FAVORITE', response.data.data.is_favorite)
                    commit('SET_AGRIIPROTECTOR_STATUS', 'idle')
                }).catch(() => {
                    commit('SET_AGRIIPROTECTOR_STATUS', 'idle')
                    dispatch('fetchAgriiProtector', payload)
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                })
        }
    },
    getters: {
        agriiProtectorStatus: (state) => {
            return state.status
        },
        agriiProtector: (state) => {
            if(state.agriiProtector) {
                return state.agriiProtector
            }
        },
        agriiProtectorNote: (state) => {
            if(state.agriiProtector && state.agriiProtector.notes && state.agriiProtector.notes.length > 0) {
                return state.agriiProtector.notes[0].note
            }
        }
    }
}
